import { populate } from 'populate';
import { DefaultQuestsSubLayout } from 'Layouts/Quests/DefaultQuestsSubLayout';

const raw = {
    width: 640,
    height: 960,
    x: 0,
    y: 0,
    list: [
        {
            id: '6a177785-355f-4cfa-854f-fcacd8a744a3',
            type: 'Container',
            name: 'root',
            nameSpace: '',
            className: '',
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            hitArea: {
                type: 'None',
            },
            parent: '',
            data: '',
        },
        {
            id: 'b529eca4-73c3-4c5d-be99-e52969959c13',
            type: 'Layout',
            name: 'subLayout',
            nameSpace: '',
            className: '',
            path: 'src/Layouts/Quests/DefaultQuestsSubLayout.ts',
            percentX: 0,
            percentY: 0,
            x: 0,
            y: 0,
            scale: {
                x: 1,
                y: 1,
            },
            pivot: {
                x: 0,
                y: 0,
            },
            angle: 0,
            alpha: 1,
            visible: true,
            interactive: false,
            buttonMode: false,
            parent: '6a177785-355f-4cfa-854f-fcacd8a744a3',
            data: '',
        },
    ],
} as const;

export class DefaultQuestsPopupLayout {
    static raw = raw;
    root: PIXI.Container;
    subLayout: DefaultQuestsSubLayout;

    constructor() {
        populate(this, raw);
    }
}
